import { Component, Input, OnInit } from '@angular/core';
import { FinalSolutionStateEnum } from '@app/ps/enums/final-solution-state.enum';

@Component({
  templateUrl: './occupations-approve-change-final-solution-type-finish.component.html',
})
export class OccupationsApproveChangeFinalSolutionTypeFinishComponent implements OnInit {
  @Input()
  data: any;
  @Input()
  newOperation: Function;
  @Input()
  goToList: Function;

  readonly FinalSolutionStateEnum = FinalSolutionStateEnum;

  ngOnInit() {
  }

  getActionLabel(count?: number): string {
    const approved = this.data.details.action === FinalSolutionStateEnum.APPROVED;
    const n = count || 0;
    if (n === 1) return approved ? 'schválen' : 'zamítnut';
    if (n >= 2 && n <= 4) return approved ? 'schváleny' : 'zamítnuty';
    return approved ? 'schváleno' : 'zamítnuto';
  }
}
